// Date helpers for the Wastage Tracking filters.
//
// Format a Date as a calendar `YYYY-MM-DD` string using its LOCAL components.
// `d.toISOString().split('T')[0]` converts to UTC first, so in any timezone east
// of UTC (e.g. Asia/Kolkata, UTC+5:30) local midnight maps to the previous
// calendar day — shifting the wastage date filters back a day (issue #248).
// Reading the local Y/M/D components keeps the date the user actually picked.
export function toLocalIsoDate(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function todayISO(): string {
  return toLocalIsoDate(new Date());
}

// Start of the default window. Must be computed in the same (local) timezone as
// todayISO(), otherwise the two bounds straddle timezones and the default range
// isn't a clean run of local calendar days (issue #248).
export function sevenDaysAgoISO(): string {
  const d = new Date();
  d.setDate(d.getDate() - 7);
  return toLocalIsoDate(d);
}
